<script lang="ts" setup>

  const { t } = useI18n()

</script>

<template>
  <div class="pc-confirm-mail">
    <SvgIcon
      class="icon"
      icon="confirm"
      :width="54"
      :height="36"
    />
    <div class="title">
      {{ t("authentication.confirm-mail-title") }}
    </div>
    <div
      class="rich-text"
      v-html="t('authentication.confirm-mail-rich-text')"
    />
  </div>
</template>

<style scoped>

.pc-confirm-mail {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .icon {
    display: flex;
    width: 6em;
    height: 6em;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: 2.5em;
    background-color: var(--color-secondary);
    opacity: 0.2;
  }

  .title {
    margin-bottom: 2.5rem;
    color: var(--color-secondary);
    font-family: Bariol, sans-serif;
    font-size: 2.5em;
    font-weight: bold;
    line-height: 1.15;
    text-align: center;
  }

  .rich-text {
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1.25em;
    font-weight: 600;
    line-height: 1.35;
    opacity: 0.8;
    text-align: center;

    :deep(strong) {
      color: var(--color-primary);
    }
  }
}
</style>
